import React from 'react'
import "../home/home.css"

const UnderConstruction = () => {
    return (
        <div>
            <div className="container underCon">

                <div className="row">
                    <div className="col-12">
                        <img src="assets/images/underconstruction.png" />
                    </div>
                </div>
                <div className="row">
                    <div className="col-12"><h2 className="underConText">This Page is under Construction</h2></div>
                </div>
            </div>
        </div>
    )
}

export default UnderConstruction
